import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.array.map.js";
export var BaseTransformer = /*#__PURE__*/function () {
  function BaseTransformer() {
    _classCallCheck(this, BaseTransformer);
  }
  _createClass(BaseTransformer, null, [{
    key: "fetchCollection",
    value: function fetchCollection(items) {
      var _this = this;
      var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
      return items.map(function (item) {
        return _this.fetch(item, locale);
      });
    }
  }, {
    key: "sendCollection",
    value: function sendCollection(items) {
      var _this2 = this;
      return items.map(function (item) {
        return _this2.send(item);
      });
    }
  }]);
  return BaseTransformer;
}();